import { PlcConnectionState } from './types'

export const state: PlcConnectionState = {
  plcOperationStateHistory: [],
}
